var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#F2F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4211 37H8.57885C7.70691 37 7 37.6716 7 38.4998C7 39.3287 7.70691 40 8.57885 40H39.4211C40.2931 40 41 39.3287 41 38.4998C41 37.6716 40.2931 37 39.4211 37Z",
    fill: "#D74F58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 7V33.3623C40 35.3733 38.8171 37 37.3549 37H10.6452C9.19039 37 8 35.3733 8 33.3623V7H40Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3516 24.9239C19.5231 24.9239 18.8516 25.5955 18.8516 26.4239V31.5C18.8516 32.3284 19.5231 33 20.3516 33C21.18 33 21.8516 32.3284 21.8516 31.5V26.4239C21.8516 25.5955 21.18 24.9239 20.3516 24.9239Z",
    fill: "#00468A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3516 27.4754C26.5231 27.4754 25.8516 28.1469 25.8516 28.9754V31.5C25.8516 32.3284 26.5231 33 27.3516 33C28.18 33 28.8516 32.3284 28.8516 31.5V28.9754C28.8516 28.1469 28.18 27.4754 27.3516 27.4754Z",
    fill: "#5097FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3516 29.0095C12.5231 29.0095 11.8516 29.6811 11.8516 30.5095V31.5C11.8516 32.3284 12.5231 33 13.3516 33C14.18 33 14.8516 32.3284 14.8516 31.5V30.5095C14.8516 29.6811 14.18 29.0095 13.3516 29.0095Z",
    fill: "#5097FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8516 22.5285C35.8516 21.7 35.18 21.0285 34.3516 21.0285C33.5231 21.0285 32.8516 21.7 32.8516 22.5285V31.5C32.8516 32.3284 33.5231 33 34.3516 33C35.18 33 35.8516 32.3284 35.8516 31.5V22.5285Z",
    fill: "#00468A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1022 16.2424L37.1176 15.1522L28.8046 22.2118L20.2848 17.7896L11.5756 27.1583C11.1393 27.6276 10.4095 27.6663 9.92602 27.2458C9.41955 26.8053 9.37839 26.033 9.83517 25.5412L19.7607 14.8539L28.4713 19.3878L35.5293 13.3941L34.5381 12.2969L39 12L38.1022 16.2424Z",
    fill: "#00468A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.c370eabf9f088c56e79d7d787f20b0ea.svg";
export { ForwardRef as ReactComponent };